import { ProductGeographyDto } from '@/types/webapi';
import { formatTimestamp } from '@/helpers';
import { PURCHASE_NOTIFICATION_VISIBILITY_VALUE } from '@/constants';
import { differenceInHours, fromUnixTime } from 'date-fns';

export const getGeographyText = (geography: ProductGeographyDto, translate: string): string => {
    if (geography.isAllZones) return translate;
    return geography.from === geography.to ? geography.from : `${geography.from} - ${geography.to}`;
};

export const getStatusText = (status: number | undefined, validityTime: number | undefined, translate: string): string => {
    return status && validityTime ? formatTimestamp(validityTime) : translate;
};

export const isWithinDeliveryTime = (orderTime: number, now: number = Date.now()): boolean =>
    differenceInHours(new Date(now), fromUnixTime(orderTime)) < PURCHASE_NOTIFICATION_VISIBILITY_VALUE;
